import { Moment } from "moment-timezone";
import React from "react";
import TimeSlot from "./TimeSlot";

type HoursGridProps = {
  hoursList: { dateTime: Moment; isDisabled: boolean }[];
  onSelectTime?: (dateTime: Moment) => void;
  selectedTime?: Moment | null;
};

export default function HoursGrid(props: HoursGridProps) {
  const { hoursList, onSelectTime, selectedTime } = props;
  return (
    <div className="w-full pt-4 pb-3 grid justify-items-center grid-flow-row sm:grid-flow-col grid-cols-[repeat(3,minmax(auto,1fr))] sm:grid-cols-[auto] sm:grid-rows-3 gap-x-6 gap-y-2 sm:gap-x-1 sm:gap-y-6 overflow-x-auto">
      {React.Children.toArray(
        hoursList.map(({ dateTime, isDisabled }) => (
          <TimeSlot
            dateTime={dateTime}
            isSelected={dateTime.isSame(selectedTime, "minute")}
            isDisabled={isDisabled}
            onSelectTime={onSelectTime}
          />
        ))
      )}
    </div>
  );
}
